// import useStore from './_store';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
// import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import banner from '@/components/banner.vue';
import addressGF from '@/components/address-input/gf.vue';
import copyRight from '@/components/copyRight/copy-right.vue';
import util from '@/common/util';
import { searchRealTimeListings } from '@/common/search-request';
import bannerMixins from '@/mixins/banner';
import Subscribe from './subscribe.vue';
import signLog from '../../components/sign-log';

import { adNewPhoneValid } from '@/components/registerPhoneValidPop/index.js';

import { colorBlock } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';

import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

import { OFFICE_DOMAIN } from "lofty_region/const.js"

import { buildUrl } from "@/router/index.js";

export default {
    // _getUseStore: useStore,
    i18next: {
        ns: 'md-evaluation-banner'
    },
    provide() {
        return {
            homeReportInfo: this.homeReportInfo,
            setHomeReportId: this.setHomeReportId
        };
    },
    mixins: [bannerMixins, spaceMixin(), colorMixin()],
    components: {
        banner,
        copyRight,
        'address-input': addressGF,
        Subscribe
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        return {
            agentId: 0,
            agentHtml: '',
            showCopyright: false,
            stepIconColor: '',
            step: 0, // 0: evaluation banner; 1: evaluation register; 2: evaluation report
            simpleMode: false, //  Is it streamlined evaluation model ?（ Doubtful ）  only 2 steps 
            showUnitField: false,
            defaultAddress: util.inCms ? '4004 Nowata Rd, Bartlesville, OK 74006, USA' : '', //'4004 Nowata Rd, Bartlesville, OK 74006, USA', //  The default address set when no address exists during configuration
            isTimeline: this.pageLocation.query.isTimeLine,
            address: this.pageLocation.query.address,
            unit: this.pageLocation.query.unit,
            showReport: this.pageLocation.query.isPopup === '0',
            title: '',
            subTitle: '',
            subTitleStyle: {},
            description: '',
            descriptionStyle: {},
            instruction: '',
            instructionStyle: {},
            submitText: '',
            submitStyle: {},
            suggestionCountry: 'us',
            addressInputStyle: {},
            placeholder: '',
            register: {
                title: '',
                subTitle: '',
                buttonStyle: {},
                nameType: 1,
                nameRequired: false,
                phoneRequired: true
            },
            showShadow: false,
            showLoading: false,
            showLoadingSec: false,
            reportUseZillow: true,
            report: {
                title: '',
                description: '',
                expertTips: '',
                priceTitleColor: '',
                priceTextColor: '',
                priceIconColor: '',
                // TODO:  Need to confirm here 
                useZillow: true,
                fakeData: {}
            },
            reportBgHeight: 0,
            copyrightHtml: null,
            chimeHtml: null,
            chimeLink: OFFICE_DOMAIN,
            isSkipStep2: false,
            comparableList: [],
            reportJSON: {},
            ...colorBlock,
            homeReportInfo: { id: '' },
            reportRef: null,
            chimeText: ''
        };
    },
    computed: {
        registerOption({ page }) {
            const registration = page?.registration || {};

            return {
                showFacebook: registration.showFacebook,
                showGoogle: registration.showGoogle,
                onregister: () => {
                    this.registerSuccess();
                },
                success: () => {
                    this.registerSuccess();
                }
            }
        },
        ...rootMapState(usePageStore, {
            "page": store => store.page,
            "agents": store => store.agents
        }),
        ...rootMapState(useUserStore, {
            "user": store => store.user,
            "hasLoggedIn": "hasLoggedIn"
        }),
        agentInfo({ agents, agentId }) {
            return agents[agentId] || {};
        },
        isMobile() {
            return this.platform.isMobile;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        cmpChimeText() {
            return (
                this.chimeText ??
                this.$t('md-evaluation-banner.madeInPhoenixAzBy')
            );
        },
        evaluationReportName({ isMobile }) {
            return isMobile ? 'evaluationReportMobile' : 'evaluationReportWeb';
        },
        moreLink({ page }) {
            let query = {};
            let soldPrice;
            if (this.reportJSON?.houseLow && this.reportJSON?.houseHigh) {
                soldPrice =
                    this.reportJSON?.houseLow +
                    ',' +
                    this.reportJSON?.houseHigh;
            }
            if (page.searchCenter) {
                let condition = {
                    location: {
                        zipCode: [this.reportJSON?.listing?.zipCode]
                        // streetAddress: [this.reportJSON?.listing?.address || '']
                    },
                    dayssold: ',180'
                };
                if (soldPrice) {
                    condition.soldPrice = soldPrice;
                }
                query = {
                    uiConfig: '{}',
                    condition: JSON.stringify(condition)
                }
            } else {
                let zipCode = this.reportJSON?.listing?.zipCode || '';
                query = {
                    keywordType: 'zipCode',
                    key: zipCode,
                    'sold-date': 180
                }
                if (soldPrice) {
                    query['minPrice-maxPrice'] = soldPrice;
                }
            }
            return buildUrl({
                name: 'sold-listing',
                query: {
                    zoom: 10,
                    page: 1,
                    listingSource: 'sold listings',
                    ...query,
                }
            });
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        paddingBottom() {
            return (
                (this.isMobileSize ? this.mobileBottomSpacing : this.bottomSpacing) +
                'px'
            );
        },
        shouldShowCopyright() {
            if (this.showCopyright) {
                return true; 
            }
            let hasSimple = this.$root.moduleData.some(item => {
                return item.name == 'md-footer';
            });
            return !hasSimple;
        },
        isShowSubscribe() {
            return this.homeReportInfo.id && !this.isTimeline;
        }
    },
    created() {
        this.showLoadingSec = this.address && this.user;
        ['report', 'register'].forEach(val => {
            this[val] = Object.assign({}, this.$data[val], this[val]);
        })
        this.init();
    },
    beforeMount() {
        this.reportBgHeight = document.documentElement.clientHeight;
        this.initSignLogRegister()
    },
    watch: {
        //  should not contain this logic 
        user(val) {
            // user exists , and not enabled  disableJump  trigger initialization when 
            if (val && !val.disableJump) {
                this.init();
            }
        },
        step(step) {
            if (this.theme === 'tips' && step === 1) {
                util.enableScroll(false);
            } else {
                util.enableScroll(true);
            }
        }
    },
    methods: {
        ...rootMapActions(usePageStore, {
            "getAgentInfo": "getAgentInfo"
        }),
        
        onRef(e) {
            this.reportRef = e;
        },
        init() {
            if (this.theme === 'tips') {
                // order is   1( register ) -> 0 -> 2(report)
                this.step = 1;
                if (
                    (this.address && (this.user || this.isSkipStep2)) ||
                    this.showReport
                ) {
                    this.step = 2;
                } else if (this.user) {
                    this.step = 0;
                }
            } else {
                if (this.address) {
                    if (this.user || this.isSkipStep2 || this.showReport) {
                        //  if logged in   Get it directly report
                        this.step = 2;
                    } else if (this.simpleMode) {
                        this.step = 2;
                    } else {
                        this.step = 1;
                    }
                }
            }
            // If step 2 is skipped ， Then judge whether it is currently step 2 during initialization ， if yes ， return to step 1 
            if (this.isSkipStep2 && this.step == 1) {
                this.step = 0;
            }
            let { country } = this.page || {};
            //  Search cities from global deconstruction 
            this.suggestionCountry =
                (typeof country === 'string' && country) || 'usa';
        },
        initSignLogRegister() {
            if (this.theme !== 'tips' && this.address !== '' && !this.user && !this.isSkipStep2 && !this.showReport && this.simpleMode) {
                signLog.register({
                    allowClose: false,
                    registerSubTitle: '',
                    languageTextFn: {
                        registerTitle: _ =>
                            '<i class="iconfont icon-lock" style="margin-right:10px;font-size:20px;"></i>' +
                            this.$t(
                                'md-evaluation-banner.unlockTheReportBy'
                            )
                    }
                });
            }
        },
        trackAddress(address) {
            // Buried event 
            this.$EventBus.$emit('siteTrack', {
                address,
                trackType: 'evaluationSubmitAddress',
                ele: this.$el
            });

            if (this.hasLoggedIn) {
                this.$EventBus.$emit('siteTrack', {
                    trackType: 'seller_home_evaluation',
                    address
                });
            }
        },
        submitAddress(address, data, callback) {
            this.trackAddress(address);
            //  show wait box 
            if (this.theme !== 'tips') {
                this.showLoading = true;
            } else {
                this.showLoadingSec = true;
            }
            this.address = address;
            this.unit = data.unit;
            this.axiosIns.get('/api-site/evaluation/partial-lead', {
                params: {
                    address,
                    unit: data.unit
                }
            });
            //  replace  url  of  address  and  unit
            this.changeUrl(address);
            if (this.user || this.isSkipStep2) {
                //  if logged in   Get it directly report
                this.step = 2;
                this.$nextTick(() => {
                    this.reportRef?.getReport();
                });
            } else if (this.simpleMode) {
                this.step = 2;
                signLog.register({
                    allowClose: false
                });
            } else {
                this.step = 1;
                this.registerMounted();
            }
            callback && callback();
        },
        registerSuccess() {
            //  After successful registration   skip to next step 
            this.showLoading = false;
            if (this.theme !== 'tips') {
                this.showLoadingSec = true;
                this.step = 2;
                adNewPhoneValid.openRegisterPhoneValidPop();
            } else {
                this.step = 0;
                this.pageLocation.href =
                    '//static.chimeroi.com/8_Tips_for_selling_a_home.docx';
            }
        },
        changeUrl(address) {
            if (util.isSSRServer) {
                return; 
            }
            var url = this.pageLocation.href;
            var urls = {};
            if (address) {
                urls.address = address;
                this.address = address;
            }
            if (this.unit) {
                urls.unit = this.unit;
            }
            var newUrl = util.setQueryField(urls, url);
            history.replaceState(null, null, newUrl);
        },
        registerMounted() {
            util.timeout({
                handler: () => {
                    this.showLoading = false;
                },
                delay: 500,
                unique: true
            });
        },
        reportMounted() {
            // report Module loading complete 
            // loading1 and 2 hide 
            this.showLoading = false;
            this.showLoadingSec = false;
        },
        getReport(res) {
            //  pull history 
            this.reportHistory = (res.report && res.report.history) || [];
            // TODO:  The meaning of this field , The map also needs to be updated 
            if (res.listing) {
                //  pull comparison value 
                // this.getComparableHome(res.listing.address);
                this.getNearbyListing(res);
                this.reportJSON = res;
            }
        },
        getNearbyListing(res) {
            let { agentInfo = {}, listing } = res || {};
            // const isSearchCenter = SiteInfo.currentSite.searchCenter;
            let soldPrice;
            if (res.houseLow && res.houseHigh) {
                soldPrice = res.houseLow + ',' + res.houseHigh;
            }

            let params = {
                siteId: agentInfo.siteId,
                layoutType: 'grid',
                listingSort: 'MLS_LIST_DATE_L_DESC',
                listingType: 'sold-listing',
                page: 1,
                pageSize: 3
            };
            if (this.page.searchCenter) {
                params.condition = {
                    soldprice: soldPrice,
                    location: {
                        zipCode: [listing.zipCode]
                    },
                    dayssold: ',180'
                };
                if (soldPrice) {
                    params.condition.soldPrice = soldPrice;
                }
            } else {
                params.key = listing.zipCode;
                params.keywordType = 'zipCode';
                params['sold-date'] = 180;
                if (soldPrice) {
                    params['minPrice-maxPrice'] = soldPrice;
                }
            }
            // TODO:  Whether to configure  zoom
            searchRealTimeListings.call(this, { params, globalData: this.page }).then(res => {
                let { listings } = res || {};
                this.comparableList = listings || [];
            });
        },
        setHomeReportId(reportId) {
            this.homeReportInfo.id = reportId;
            util.setQueryField({ reportId }, true);
        },
    }
};
